export var EverflowEvents;
(function (EverflowEvents) {
  EverflowEvents[EverflowEvents["LEAD"] = 1] = "LEAD";
  EverflowEvents[EverflowEvents["CUSTOMER"] = 2] = "CUSTOMER";
  EverflowEvents[EverflowEvents["IPB_APPLICATION_COMPLETE"] = 5] = "IPB_APPLICATION_COMPLETE";
  EverflowEvents[EverflowEvents["MEMBERSHIP_PLAN_CONFIRMED"] = 7] = "MEMBERSHIP_PLAN_CONFIRMED";
  EverflowEvents[EverflowEvents["PLAID_LINK_STARTED"] = 8] = "PLAID_LINK_STARTED";
  EverflowEvents[EverflowEvents["PLAID_LINK_CONFIRMED"] = 9] = "PLAID_LINK_CONFIRMED";
})(EverflowEvents || (EverflowEvents = {}));